// Remove free shipping banner with specific text, blue bar, and exit button
document.addEventListener('DOMContentLoaded', function() {
  // Function to remove elements containing the free shipping text and related components
  function removeFreeShippingBanner() {
    console.log('Scanning for free shipping banner elements to remove...');
    
    // Remove all elements with mars classes (comprehensive)
    const marsSelectors = [
      '[class*="076-mars"]',
      '[class*="mars14"]',
      '[class*="mars15"]',
      '[class*="mars16"]',
      '[class*="mars17"]',
      '[class*="mars18"]',
      '[class*="mars19"]'
    ];
    
    marsSelectors.forEach(function(selector) {
      const elements = document.querySelectorAll(selector);
      elements.forEach(function(element) {
        element.remove();
        console.log('Removed mars element:', element.className);
      });
    });
    
    // Remove MUI components related to the banner
    const muiSelectors = [
      '[class*="076-MuiButtonBase-root"]',
      '[class*="076-MuiIconButton-root"]',
      '[class*="076-MuiButton"]',
      '[class*="076-Mui"]',
      'button[class*="076-"]',
      '[class*="076-"] button'
    ];
    
    muiSelectors.forEach(function(selector) {
      const elements = document.querySelectorAll(selector);
      elements.forEach(function(element) {
        element.remove();
        console.log('Removed MUI component:', element.className || element.tagName);
      });
    });
    
    // Remove elements with blue background (dark blue colors)
    const allDivs = document.querySelectorAll('div');
    allDivs.forEach(function(div) {
      const style = div.style;
      const computedStyle = window.getComputedStyle(div);
      
      // Check for blue background colors
      const backgrounds = [
        style.backgroundColor,
        style.background,
        computedStyle.backgroundColor,
        computedStyle.background
      ];
      
      backgrounds.forEach(function(bg) {
        if (bg && (
          bg.includes('rgb(0, 0, 70)') ||
          bg.includes('#000046') ||
          bg.includes('navy') ||
          bg.includes('darkblue') ||
          bg.includes('rgb(0, 70, 140)') ||
          bg.includes('rgb(13, 60, 97)') ||
          bg.includes('#0d3c61')
        )) {
          div.remove();
          console.log('Removed blue background element');
        }
      });
    });
    
    // Search for all span elements with free shipping text
    const allSpans = document.querySelectorAll('span');
    allSpans.forEach(function(span) {
      // Check if span contains the specific text
      if (span.textContent.includes('Free shipping on orders over $70.00') || 
          span.textContent.includes('👋 Free shipping on orders over $70') ||
          span.textContent.includes('Free shipping on orders over')) {
        
        // Find and remove parent containers
        let parent = span.parentElement;
        let attempts = 0;
        
        while (parent && attempts < 15) {
          // Check if parent has mars class or is a likely container
          if (parent.className && (
            parent.className.includes('076-mars') ||
            parent.className.includes('076-Mui') ||
            parent.className.includes('free-shipping') ||
            parent.className.includes('announcement') ||
            parent.className.includes('promo-bar')
          )) {
            parent.remove();
            console.log('Removed banner parent container:', parent.className);
            break;
          }
          
          // If we've gone up far enough, remove the span itself
          if (attempts === 14) {
            span.remove();
            console.log('Removed free shipping span');
          }
          parent = parent.parentElement;
          attempts++;
        }
      }
    });
    
    // Remove close/exit buttons with specific attributes
    const closeButtons = document.querySelectorAll([
      'button[aria-label*="close"]',
      'button[aria-label*="dismiss"]',
      '[class*="close-button"]',
      '[class*="exit-button"]',
      'button[class*="076-"]'
    ].join(', '));
    
    closeButtons.forEach(function(button) {
      button.remove();
      console.log('Removed close/exit button');
    });
    
    // Remove common app containers
    const appContainers = document.querySelectorAll([
      '.free-shipping-bar',
      '.announcement-bar-app',
      '[data-free-shipping-bar]',
      '[id*="free-shipping"]',
      '[class*="free-shipping-bar"]',
      '[class*="shipping-bar"]',
      '[class*="promo-bar"]',
      '[class*="top-banner"]'
    ].join(', '));
    
    appContainers.forEach(function(container) {
      container.remove();
      console.log('Removed app container:', container.className || container.id);
    });
    
    // Additional nuclear approach: Remove any element with blue styling
    const allElements = document.querySelectorAll('*');
    allElements.forEach(function(element) {
      const styles = window.getComputedStyle(element);
      const bgColor = styles.backgroundColor;
      const color = styles.color;
      
      // Check for blue-ish colors and remove if they contain shipping text
      if ((bgColor.includes('rgb(0, 0, 70)') || 
           bgColor.includes('rgb(13, 60, 97)') || 
           bgColor.includes('#0d3c61') ||
           bgColor.includes('navy') ||
           bgColor.includes('darkblue')) &&
          element.textContent.toLowerCase().includes('shipping')) {
        element.remove();
        console.log('Removed blue shipping element');
      }
    });
    
    // Remove any iframes that might contain the banner
    const iframes = document.querySelectorAll('iframe');
    iframes.forEach(function(iframe) {
      if (iframe.src && (
        iframe.src.includes('free-shipping') ||
        iframe.src.includes('shipping-bar') ||
        iframe.src.includes('announcement')
      )) {
        iframe.remove();
        console.log('Removed shipping iframe');
      }
    });
    
    // Check for elements with specific data attributes
    const dataElements = document.querySelectorAll([
      '[data-app="free-shipping"]',
      '[data-component*="shipping"]',
      '[data-widget*="shipping"]',
      '[data-banner*="shipping"]'
    ].join(', '));
    
    dataElements.forEach(function(element) {
      element.remove();
      console.log('Removed data attribute element');
    });
  }
  
  // Run immediately
  removeFreeShippingBanner();
  
  // Run again after a delay (in case content is loaded dynamically)
  setTimeout(removeFreeShippingBanner, 1000);
  setTimeout(removeFreeShippingBanner, 3000);
  
  // Watch for dynamically added content
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
          removeFreeShippingBanner();
        }
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
});